import styled from "styled-components"

export const Content = styled.div`
  padding: 5px 10px;
  border-radius: 1em;
  white-space: pre-line;
`
